module.exports = __webpack_public_path__ + "static/crew-staticLR-c2829d82e7933d09660d68c5e6a89dc7.jpg";